<template>
    <el-dialog
      :visible.sync="isOpen"
      :show-close="true"
      class="egl-dialog-elm channel-dialog"
      :title="$locale('sideMenu.shop.ingredient') + actionText"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="detailForm" :rules="formRules" :disabled="!isEdit">
        <div class="form-module">
          <div class="form-module-tit">{{ $locale("global.basicInfo") }}</div>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item class="long-item" :label="$locale('global.name')" prop="name">
                <el-input v-model="form.name" :placeholder="$locale('form.plsEnterYourName')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <div class="special-item">
                <ShopProductPrice
                :formData="form"
                :taxRate="form.taxRateCost"
                taxIncludeName="stockPrice"
                :roundType="brandSetting.round"
                ></ShopProductPrice>
            </div>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$locale('global.unit')" class="long-item" prop="unit">
                <el-input v-model="form.unit" :placeholder="$locale('form.plsEnterUnit')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$locale('shop.consumptionTax_purchaseCost')"
                class="long-item"
                prop="taxRateCost"
              >
                <TaxSelect v-model="form.taxRateCost" :isSaleOption="true"></TaxSelect>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$locale('shop.stockLocation')" class="long-item" prop="stockPlace">
                <el-input v-model="form.stockPlace" :placeholder="$locale('shop.plsEnterStockLocation')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$locale('shop.supplier')" class="long-item" prop="clientId">
                <!-- <el-select v-model="form.clientId" :filterable="true" :clearable="true">
                  <el-option
                    v-for="item in clientList"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select> -->
                <!-- <template v-if="isOpen">
                  <remote-select
                    type="client"
                    :isMultiple="false"
                    v-model="form.clientId"
                    :formValue.sync="form.clientId"
                    :actionType="action"
                  ></remote-select>
                </template> -->
                <RemoteSelectV2
                  ref="selectV2Client"
                  type="client"
                  :list="comClientList"
                  v-model="form.clientId"
                  :isMultiple="false"
                  :formValue.sync="form.clientId"
                  :fields="['id', 'name']"
                  @setList="arr => comClientList = arr"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$locale('bookKeeping.journal.dept')+' ('+$locale('setting.pay.accgroup')+')'" class="long-item">
                <el-select v-model="form.journalType">
                  <el-option v-for="item in tradeGroupList"
                    :label="item.name"
                    :key="item.id"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$locale('shop.productType')" class="long-item" prop="productType">
                  <el-select v-model="form.productType" disabled>
                    <el-option
                      v-for="item in productTypeOption"
                      :label="item.label"
                      :value="item.val"
                      :key="item.val"
                    ></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <ApproveField v-if="!form.isApprove" v-model="form.reflectDate" :formData="form" fieldName="reflectDate" />
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="this.action != 'detail'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button class="egl-btn-white" @click="colse_fn">{{$locale("global.cancel")}}</el-button>
            <el-button class="egl-btn-yellow" @click="save_fn">{{$locale("global.confirm")}}</el-button>
          </el-col>
        </el-row>
      </div>
  </el-dialog>
</template>

<script>
import TaxSelect from "@/components/common/TaxSelect";
import ShopProductPrice from "@/components/common/ShopProductPrice";
import ApproveField from "@/components/common/ApproveField";
import { setFormHandler } from "@/utils/approve.js";
import { getListService } from "@/helpers/service/api/tradeGroup";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getClientListService } from "@/helpers/service/api/common";
import { decimal2 } from "@/utils/utils";

export default {
  name: "IngredientDialog",
  data() {
    return {
      visible: false,
      actionText: "",
      form: this.createForm(),
      tradeGroupList: [],
      productTypeOption: [
        {
          label: this.$locale("global.purchase"),
          val: "SALES_ITEM",
        },
      ],
      formRules: {
        name: [ {
          required: true,
          message: this.$locale("form.plsEnterYourName"),
          trigger: "blur",
        } ],
        taxRateCost: [ {
          required: true,
          message: this.$locale("form.plsEnterPrice"),
          trigger: "change",
        } ],
        productType: [ {
          required: true,
          message: this.$locale("shop.plsSelectProductType"),
          tirgger: "change",
        } ],
      },
      comClientList: [],
      decimal2,
    };
  },
  methods: {
    getTradeGroup() {
      getListService({
        brandId: window.localStorage.getItem("brandId"),
      }).then(res => {
        this.tradeGroupList = res.data;
      });
    },

    colse_fn() {
      this.$emit("closeFn");
    },
    save_fn() {
      this.$refs.detailForm.validate(valid => {
        if (valid) {
          let data = { ...this.form };
          this.$emit("returnMsg", data);
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });

    },
    createForm() {
      return {
        name: "",
        stockPrice: 0,
        priceWithoutTax: 0,
        unit: "",
        stockPlace: "",
        clientId: "",
        journalType: "",
        taxRateCost: "percentTen",
        productType: "SALES_ITEM",
        reflectDate: this.$moment().startOf("day").valueOf(),
      };
    },
    setForm(data) {
      setFormHandler(this.form, "reflectDate", data);
    },
    changeUnit(value) {
      this.form.unit = decimal2(value)
    }
  },
  mounted() {},
  async created() {
    // await this.getTradeGroup();
  },
  computed: {
    isOpen: {
      get() {
        return this.visible;
      },
      set() {
        this.colse_fn();
      },
    }
  },
  props: {
    action: {
      type: String,
      default: "",
    },
    detailObj: {
      type: Object,
      default: () => {},
    },
    clientList: {
      type: Array,
      default: () => [],
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    brandSetting: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    action() {
      let visible = false;
      let actionText = "";
      let form = { ...this.createForm(), ...this.detailObj, };

      if (this.action != "") {
        visible = true;
      } else {
        visible = false;
      }

      if (this.action == "create") {
        actionText = this.$locale("global.create");
      } else {
        actionText = this.$locale("global.edit");
      }

      this.actionText = actionText;
      if (this.$refs.detailForm) {
        this.$refs.detailForm.resetFields();
      }
      this.form = form;
      this.visible = visible;
    },
    isOpen(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs["selectV2Client"].page = 1;
          if (this.tradeGroupList.length === 0) this.getTradeGroup()
          if (this.action !== "create") {
            if (this.form.clientId) {
              getClientListService({
                ids: [ this.form.clientId ],
                page: 0,
                pageSize: 9999,
                field: ["id", "name"]
              }).then(res => {
                this.comClientList = this.$_.uniqBy(res.data.data.concat(this.clientList), "id");
              });
            }
          } else {
            this.comClientList = this.clientList;
          }
        });
      }
    }
  },
  components: {
    ApproveField,
    TaxSelect,
    ShopProductPrice,
    RemoteSelectV2,
  }
};
</script>

